<unity-page-container [contentHeader]="$contentHeader()" [contentHeaderSecondary]="$contentSecondaryHeader()" [isLoading]="$isLoading()">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>
  @let formGroup = $formGroup();
  <unity-card-new-shared actionName="Create" [formGroup]="formGroup" [formLoading]="$formLoading()" (submitEvent)="onSubmit()">
    <unity-textbox-control displayName="Name" description="Provide the Template name." [control]="formGroup.controls.name" />
    <unity-textarea-control
      displayName="Description"
      description="Provide the template description."
      [control]="formGroup.controls.description" />
    <unity-dropdown-form-types-control
      displayName="Form Type"
      description="Select the type of form to create."
      [selectable]="$selectableFormTypes()"
      [control]="formGroup.controls.type_id" />
    <unity-dropdown-workflow-control
      displayName="Workflow"
      description="Select the workflow used for this form."
      [control]="formGroup.controls.default_workflow_id" />
    <unity-survey-creator-control
      displayName="Form Creator"
      description="Click to launch the form creator and start designing a the form."
      [control]="formGroup.controls.data" />
    <ng-content submit-options>
      <unity-action-cancel-shared [disabled]="false" [action]="returnToDashboardAction" />
    </ng-content>
  </unity-card-new-shared>
</unity-page-container>
